import { GenericProps } from '@lumx/react/utils/type';
import type { LumxClassName } from '@lumx/core/js/types';
import { classNames } from '@lumx/core/js/utils';
import { forwardRef } from '@lumx/react/utils/react/forwardRef';

/**
 * Defines the props of the component.
 */
export type ListDividerProps = GenericProps;

/**
 * Component display name.
 */
const COMPONENT_NAME = 'ListDivider';

/**
 * Component default class name and class prefix.
 */
const CLASSNAME: LumxClassName<typeof COMPONENT_NAME> = 'lumx-list-divider';

/**
 * ListDivider component.
 * Purely decorative, consider a `ListSection` with label for a better list structure.
 *
 * @param  props Component props.
 * @param  ref   Component ref.
 * @return React element.
 */
export const ListDivider = forwardRef<ListDividerProps, HTMLLIElement>((props, ref) => {
    const { className, ...forwardedProps } = props;

    return <li ref={ref} role="none" {...forwardedProps} className={classNames.join(className, CLASSNAME)} />;
});
ListDivider.displayName = COMPONENT_NAME;
ListDivider.className = CLASSNAME;
